import  React from 'react';
import { BloodworkDisplayContainer } from './containers/bloodwork-display-container';
import { Container } from 'react-bootstrap';

export class Home extends React.Component<{}, {}> {
  componentWillUpdate() {
    this.scrollTop();
  }

  scrollTop() {
    document.body.scrollTop = 0; 
    document.documentElement.scrollTop = 0;
  }

  render() {
    return (  
      <Container fluid>    
        <BloodworkDisplayContainer {...this.props} />
      </Container>
    );
  }
}
